import { ReactNode, useEffect, useState } from "react";
import BasicInformation from "../BasicInformation/BasicInformation";
import "./Verify.scss";
import ProfessionalDetails from "../ProfessionalDetails/ProfessionalDetails";
import { ADMIN_ROLES, API_RESPONSE, BANKING_INFORMATION, I18_TRANSLATION_COMMON, MODES, NUMBER_CONSTANTS, PROFESSIONAL_DETAILS, REGISTRATION_FORM, ROUTES, STORAGE_KEYS, TOKENS, VALIDATION_CONSTANT } from "../../../../Utilities/Constants/Constants";
import { Card, Chip, MenuItem, Select } from "@mui/material";
import { ERROR_MESSAGES, REGEX, REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import * as yup from "yup";
import { Field, Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useTranslation } from "react-i18next";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import driveImg from "../../../../../Assets/Registration/drive.svg";
import { GetSessionStorageData, SetSessionStorageData, clearSessionKey } from "../../../../Services/Helpers/Helper";
import { useNavigate } from "react-router-dom";

const Verify = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [activeStep, setActiveStep] = useState(NUMBER_CONSTANTS.ZERO);
  const [phoneNumber, setPhoneNumber]: any = useState("");
  const [currentGender, setCurrentGender] = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(API_RESPONSE.TRUE);
  const [registrationDetail, setRegistrationDetail]: any = useState({});
  const [userType, setuserType]: any = useState("");
  const [viewerFile, setViewerFile] = useState("");
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const [isSchoolUniversityReg, setIsSchoolUniversityReg] = useState(API_RESPONSE.FALSE)
  const [initialValue, setInitialValue]: any = useState({
    [REGISTRATION_FORM.FIRST_NAME]: "",
    lastname: "",
    email: "",
    phone_number: "",
    // roles: "",
    about_me: "",
    gender: "",
    nationality: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    dob: "",
    country: "",
    country_code: "",
    latitude: "",
    longitude: "",
  });

  const navigate = useNavigate();
  /* Set Active state */
  const setActiveStatus = (status: any) => {
    setActiveStep(status);
  };

  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));

  }, []);

  useEffect(() => {
  }, [registrationDetail])



  useEffect(() => {
    if (userType === ADMIN_ROLES.UNIVERSITY || userType === ADMIN_ROLES.SCHOOL) {
      setIsSchoolUniversityReg(API_RESPONSE.TRUE)
    } else {
      setIsSchoolUniversityReg(API_RESPONSE.FALSE)
    }

    if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
      getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS)
    } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
      getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS)
    } else if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
      getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
    } else if (userType === ADMIN_ROLES.SCHOOL || userType === ADMIN_ROLES.UNIVERSITY) {
      getRegistrationDetail(API_END_POINTS.SCHOOL_UNIVERSITY_DETAILS);
    }
    else if (userType === ADMIN_ROLES.EDUCATIONAL_EXPERT) {
      getRegistrationDetail(API_END_POINTS.EXPERTS_REGISTRATION);
    }

  }, [userType]);

  const getRegistrationDetail = (END_POINTS: any) => {
    axiosInstance.get(END_POINTS).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setRegistrationDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
      }
    })
  }

  /* Navigate Call */
  const onNavigate = (state: any) => {
    props.activeStatus(state)
  };

  const formValidationSchema = yup.object({
    firstname: yup
      .string()
      .min(NUMBER_CONSTANTS.FOUR)
      .required(REGISTRATION_ERRORS.FIRST_NAME)
      .trim(),
    lastname: yup.string().required(REGISTRATION_ERRORS.LAST_NAME),
    email: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL),
    phone_number: yup.string().required(ERROR_MESSAGES.PHONE_NUMBER),
    // roles: yup.string().required(),
    about_me: yup.string().required(REGISTRATION_ERRORS.ABOUT_ME),
    gender: yup.string().required(REGISTRATION_ERRORS.GENDER_ERR),
    nationality: yup.string().required(REGISTRATION_ERRORS.NATIONALITY),
    address: yup.string().required(REGISTRATION_ERRORS.ADDRESS),
    city: yup.string().required(REGISTRATION_ERRORS.CITY),
    state: yup.string().required(REGISTRATION_ERRORS.STATE),
    pincode: yup.string().required(REGISTRATION_ERRORS.PINCODE),
    dob: yup.string().required(REGISTRATION_ERRORS.DOB),
    country: yup.string().required(REGISTRATION_ERRORS.COUNTRY),
    country_code: yup.string().required(REGISTRATION_ERRORS.COUNTRY_CODE),
    // latitude: yup.string().required(REGISTRATION_ERRORS.LATITUDE),
    // longitude: yup.string().required(REGISTRATION_ERRORS.LONGITUDE),
  });

  /* Validate phone number */
  const validatePhoneNumber = (e: any) => {
    isValidPhoneNumber(e);
    isValidPhoneNumber(e) === API_RESPONSE.TRUE
      ? setValidPhoneNumber(API_RESPONSE.TRUE)
      : setValidPhoneNumber(API_RESPONSE.FALSE);
    return isValidPhoneNumber(e);
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };

  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  const onSaveDetails = (API: any, number: any) => {
    if (number !== NUMBER_CONSTANTS.FOUR) {
      registrationDetail.firstname = registrationDetail.profile_details.firstname;
      registrationDetail.lastname = registrationDetail.profile_details.lastname;
      registrationDetail.email = registrationDetail.profile_details.email;
      registrationDetail.phone_number = registrationDetail.profile_details.phone_number;
    }
    let API_URL: any = '';
    if (number === NUMBER_CONSTANTS.FOUR) {
      let type = userType === ADMIN_ROLES.SCHOOL ? NUMBER_CONSTANTS.ONE : NUMBER_CONSTANTS.TWO;
      API_URL = `&${VALIDATION_CONSTANT.TYPE_INFO}=` + type;
    }

    axiosInstance.put(API + `?${VALIDATION_CONSTANT.PAGE}=` + number + API_URL, registrationDetail).then(response => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        SetSessionStorageData(STORAGE_KEYS.ID, response.data.result.data.id);
        SetSessionStorageData(TOKENS.ACCESS_TOKEN, GetSessionStorageData(TOKENS.TEMPORARY_TOKEN));
        clearSessionKey(TOKENS.TEMPORARY_TOKEN)
        navigate(ROUTES.ONBOARDING_SCREEN);
      };
    });
  }

  const onRegisterSP = () => {
    if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
      onSaveDetails(API_END_POINTS.TUTOR_VERIFY, NUMBER_CONSTANTS.SIX)
    } else if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
      onSaveDetails(API_END_POINTS.CAMP_VERIFY, NUMBER_CONSTANTS.SIX)
    } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
      onSaveDetails(API_END_POINTS.PERSONAL_VERIFY, NUMBER_CONSTANTS.SIX)
    } else if (userType === `${NUMBER_CONSTANTS.THREE}`) {
      onSaveDetails(API_END_POINTS.EXPERTS_REGISTRATION, NUMBER_CONSTANTS.SIX)
    } else {
      onSaveDetails(API_END_POINTS.SCHOOL_UNIVERSITY_STEPPERS, NUMBER_CONSTANTS.FOUR)
    }
  }

  return (
    <div className="row verify-wrapper">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <FileViewerDialog
          open={fileViewerOpen}
          handleClose={onFilerViewerDialogClose}
          viewerFile={viewerFile}
        ></FileViewerDialog>
        <Card className="bi-wrapper">
          <div>

            <Formik
              initialValues={initialValue}
              enableReinitialize={true}
              validationSchema={formValidationSchema}
              onSubmit={(values, actions) => {
                // onSaveBasicInformation(values);
              }}
            >
              {(formik: any) => {
                return (
                  <div>
                    <div>
                      <h4 className="header-title">Basic Information</h4>
                      {GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FIVE && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-items">
                              <label className="form-label">{t("Camp Name")}</label>
                              <Field
                                name={REGISTRATION_FORM.CAMP_NAME}
                                className="email-input"
                                placeholder={t("Camp Name")}
                                disabled={true}
                                value={registrationDetail?.campname}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {isSchoolUniversityReg && <div className="row">
                        <div className="col-md-12">
                          <div className="form-items">
                            <label className="form-label">{t(userType === ADMIN_ROLES.SCHOOL ? "School Name" : "University Name")}</label>
                            <Field
                              name={REGISTRATION_FORM.NAME}
                              className="email-input"
                              placeholder={t(userType === ADMIN_ROLES.SCHOOL ? "School Name" : "University Name")}
                              disabled={true}
                              value={registrationDetail?.name}
                            />
                          </div>
                        </div>
                      </div>}
                      <div className="row row-wrap">
                        {isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t(userType === ADMIN_ROLES.SCHOOL ? "School Email" : "University Email")}</label>
                            <Field
                              name={REGISTRATION_FORM.EMAIL}
                              className="email-input"
                              placeholder={t("Email")}
                              value={registrationDetail?.email}
                              disabled={true}
                            />

                          </div>
                        </div>}

                        {isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Authority name")}</label>
                            <Field
                              name={REGISTRATION_FORM.FIRST_NAME}
                              className="email-input"
                              placeholder={t("First name")}
                              disabled={true}
                              value={registrationDetail?.authority_name}
                            />
                          </div>
                        </div>}
                        {!isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("First name")}</label>
                            <Field
                              name={REGISTRATION_FORM.FIRST_NAME}
                              className="email-input"
                              placeholder={t("First name")}
                              disabled={true}
                              value={registrationDetail?.profile_details?.firstname}
                            />
                          </div>
                        </div>}
                        {!isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Last name")}</label>
                            <Field
                              name={REGISTRATION_FORM.LAST_NAME}
                              className="email-input"
                              placeholder={t("Last name")}
                              disabled={true}
                              value={registrationDetail?.profile_details?.lastname}
                            />
                          </div>
                        </div>}
                      </div>
                      {!isSchoolUniversityReg && <div className="row row-wrap">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <div className="form-items">
                            <label className="form-label">{userType === `${NUMBER_CONSTANTS.FIVE}` ? t("About Camp") : t("About me")}</label>
                            <Field
                              as="textarea"
                              name={REGISTRATION_FORM.ABOUT_ME}
                              className="email-input input-textarea"
                              placeholder={t("About me")}
                              disabled={true}
                              value={userType === `${NUMBER_CONSTANTS.FIVE}` ? registrationDetail?.about_camp : registrationDetail?.about_me}
                            />
                          </div>
                        </div>
                      </div>}

                      <div className="row row-wrap">

                        {isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Authority Email")}</label>
                            <Field
                              name={REGISTRATION_FORM.EMAIL}
                              className="email-input"
                              placeholder={t("Email")}
                              value={registrationDetail?.authority_email}
                              disabled={true}
                            />

                          </div>
                        </div>}
                        {!isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Email")}</label>
                            <Field
                              name={REGISTRATION_FORM.EMAIL}
                              className="email-input"
                              placeholder={t("Email")}
                              value={registrationDetail?.profile_details?.email}
                              disabled={true}
                            />

                          </div>
                        </div>}
                        <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">
                              {t("Phone Number")}
                            </label>
                            <PhoneInput
                              inputProps={{
                                className: "input phone_num_input",
                              }}
                              country={"ae"}
                              enableSearch={true}
                              value={userType === ADMIN_ROLES.SCHOOL || userType === ADMIN_ROLES.UNIVERSITY ? registrationDetail.authority_phonenumber : registrationDetail?.profile_details?.phone_number}
                              // disabled={true}
                              disabled={true}
                              onChange={(e: any) => {
                                setPhoneNumber(e);
                                validatePhoneNumber("+" + e);
                                formik.setFieldValue(
                                  REGISTRATION_FORM.PHONE_NUMBER,
                                  "+" + e
                                );
                              }}
                              countryCodeEditable={false}
                            />
                          </div>
                        </div>
                        {!isSchoolUniversityReg && userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">{t("DOB")}</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                className={REGISTRATION_FORM.DOB}
                                openTo="day"
                                views={["day", "month", "year"]}
                                value={
                                  new Date(registrationDetail?.dob)
                                }
                                disabled={true}

                              />
                            </LocalizationProvider>
                          </div>
                        </div>}
                        {(!isSchoolUniversityReg && userType !== `${NUMBER_CONSTANTS.FIVE}`) && <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">{t("Gender")}</label>
                            <Field
                              className="email-input"
                              placeholder={t("Gender")}
                              disabled={true}
                              value={registrationDetail?.gender}
                            />

                          </div>
                        </div>}
                        {/* {!isSchoolUniversityReg && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Nationality")}</label>
                            <Field
                              name={REGISTRATION_FORM.NATIONALITY}
                              className="email-input"
                              placeholder={t("Nationality")}
                              disabled={true}
                              value={registrationDetail?.nationality}
                            />
                          </div>
                        </div>} */}
                        <div className={isSchoolUniversityReg ? "col-md-12 mt-2" : "col-md-6 mt-2"}>
                          <div className="form-items">
                            <label className="form-label">{t("Address")}</label>
                            <Field
                              name={REGISTRATION_FORM.ADDRESS}
                              className="email-input"
                              placeholder={t("Address")}
                              disabled={true}
                              value={registrationDetail?.address}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">{t("City")}</label>
                            <Field
                              name={REGISTRATION_FORM.CITY}
                              className="email-input"
                              placeholder={t("City")}
                              disabled={true}
                              value={registrationDetail?.city}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">{t("Emairate")}</label>
                            <Field
                              name={`Emirate`}
                              className="email-input"
                              placeholder={t("Emirate")}
                              disabled={true}
                              value={registrationDetail?.emirate}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-items">
                            <label className="form-label">{t("Pincode")}</label>
                            <Field
                              name={REGISTRATION_FORM.PINCODE}
                              className="email-input"
                              placeholder={t("Pincode")}
                              disabled={true}
                              value={registrationDetail?.pincode}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Country")}</label>
                            <Field
                              name={REGISTRATION_FORM.COUNTRY}
                              className="email-input"
                              placeholder={t(`Country code`)}
                              disabled={true}
                              value={registrationDetail?.country}
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>


                    {!isSchoolUniversityReg && <div>
                      <div className="mt-3">
                        <h4>Professional Details</h4>
                        <div className="row row-wrap">
                          {userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label">
                                { t("Highest Qualification")}
                              </label>
                              <Field
                                name={PROFESSIONAL_DETAILS.DEGREE}
                                className="email-input"
                                placeholder={t("Educational Qualification")}
                                value={userType === `${NUMBER_CONSTANTS.FOUR}` ? registrationDetail?.high_education : registrationDetail?.high_education}
                                disabled={true}

                              />
                            </div>
                          </div>}
                          {userType !== `${NUMBER_CONSTANTS.FIVE}` && registrationDetail?.degree!=='' && <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label">
                                { t("Degree")}
                              </label>
                              <Field
                                name={PROFESSIONAL_DETAILS.DEGREE}
                                className="email-input"
                                placeholder={t("Degree")}
                                value={registrationDetail?.degree}
                                disabled={true}

                              />
                            </div>
                          </div>}
                          {userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label">
                                { t("Degree Specialization")}
                              </label>
                              <Field
                                name={`degree_subject`}
                                className="email-input"
                                placeholder={t("Degree Specialization")}
                                value={registrationDetail?.degree_subject}
                                disabled={true}

                              />
                            </div>
                          </div>}

                        </div>

                        <div className="row row-wrap">
                          {userType === `${NUMBER_CONSTANTS.FOUR}` && <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label">{t("Curriculum")}</label>
                              <Field
                                name={PROFESSIONAL_DETAILS.CURRICULAM}
                                className="email-input"
                                placeholder={t("Curriculum")}
                                value={registrationDetail?.curriculum}
                                disabled={true}
                              />
                            </div>
                          </div>}

                        </div>

                        <div className="row row-wrap" >
                          {userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="col-md-6">
                            <label className="form-label">{t("Skills")}</label>

                            <div className="skills-list">
                              {userType === `${NUMBER_CONSTANTS.FOUR}` && registrationDetail?.skills?.map((skill: any, index: any) => {
                                return (
                                  <Chip
                                    className="skill-chip"
                                    label={skill}
                                    variant="outlined"
                                  // onDelete={handleDelete(index)}
                                  />
                                );
                              })}
                              {userType === `${NUMBER_CONSTANTS.NINE}` && registrationDetail?.specializations?.map((skill: any, index: any) => {
                                return (
                                  <Chip
                                    className="skill-chip"
                                    label={skill}
                                    variant="outlined"
                                  // onDelete={handleDelete(index)}
                                  />
                                );
                              })}
                            </div>

                          </div>}
                        </div>


                        {userType === `${NUMBER_CONSTANTS.FOUR}` && <div className="row sub-exp-wrap row-wrap">
                          <div className="col-md-12">
                            <label className="form-label">{t("Subject and Experience")}</label>
                            <div className="row">
                              {
                                registrationDetail?.subject_and_experience?.map((course: any, index: any) => {
                                  return (
                                    <div className="col-xs-12 col-sm-12 col-md-4 detail-wrapper" >
                                      <div className="session_card_container">

                                        <div className="session_slot_count_wrapper">
                                          <div className="session_slot_count">
                                            <div className="session-count">{course.experience}</div>
                                            <div className="slot-text">Experience</div>
                                          </div>

                                        </div>
                                        <div className="session_date_details_container">
                                          <div className="session_subject">{course.subject}</div>
                                          <div className="session_grade">{course.min} </div>
                                          <div className="session_amount">{course.expected_fee} AED</div>
                                        </div>
                                      </div>

                                    </div>
                                  )
                                })
                              }

                            </div>
                          </div>


                        </div>}
                        {userType !== `${NUMBER_CONSTANTS.FOUR}` && <label className="form-label row-wrap">{t("Activities Offered")}:</label>}
                        {userType !== `${NUMBER_CONSTANTS.FOUR}` && <div className="row">
                          {registrationDetail?.activities_and_experience?.map((course: any, index: any) => {
                            return (

                              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div
                                  className="subject-detail-wrapper"
                                  key={course.id}
                                >
                                  <div className="session_slot_count_wrapper">
                                    <div className="session_slot_count">
                                      <div className="session-count">
                                        {course.experience}
                                      </div>
                                      <div className="slot-text">Experience</div>
                                    </div>
                                  </div>
                                  <div className="session_date_details_container">
                                    <div className="session_subject">
                                      {course.activity}
                                    </div>
                                    <div className="session_subject">
                                      {course.course_mode}
                                    </div>
                                    <div className="session_grade">{course.min}</div>
                                    {course.isEdit === true && (
                                      <div className="session_grade">
                                        <input
                                          value={course.expected_fee}
                                          onChange={(e: any) => {
                                          }}
                                        />
                                        AED{" "}

                                      </div>
                                    )}
                                    {!course.isEdit && (
                                      <div className="session_grade">
                                        {course.expected_fee} AED{" "}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>}

                      </div>
                    </div>}



                    <div className="mt-4">
                      <h4>Personal Information</h4>

                      <div className="row row-wrap">
                        <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("ID")}</label>
                            <Field
                              className="email-input"
                              placeholder={t("ID")}
                              value={registrationDetail?.emirates_id}
                              disabled={true}
                            />
                          </div>
                        </div>
                        {registrationDetail?.immigrant_id && <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Passport")}</label>
                            <Field
                              // name={PROFESSIONAL_DETAILS.CURRICULAM}
                              className="email-input"
                              placeholder={t("Passport")}
                              value={registrationDetail?.immigrant_id}
                              disabled={true}
                            />
                          </div>
                        </div>}

                        {registrationDetail?.trade_id &&  <div >
                          <div className="col-md-6">
                          <div className="form-items">
                            <label className="form-label">{t("Trade ID")}</label>
                            <Field
                              className="email-input"
                              placeholder={t("ID")}
                              value={registrationDetail?.trade_id}
                              disabled={true}
                            />
                          </div>
                        </div>
                          </div>}

                      </div>

                      <div className="row row-wrap">
                        <div className="col-md-6 ">
                          <div className="tutor_info_icon_label tutor_files_wrapper">

                            <div className="full-image-wrapper">
                              <img
                                onClick={() => {
                                }}
                                className="uploaded-image"
                                src={registrationDetail?.emirates_front}
                                alt="Learn and Play"
                              />
                            </div>
                            <div>
                              <label className="form-label">ID Front</label>
                              <button className="btn btn-primary" onClick={() => {
                                onFilerViewerDialogOpen(registrationDetail?.emirates_front);
                              }}>View File</button>
                            </div>

                          </div>


                        </div>

                        <div className="col-md-6 ">
                          <div className="tutor_info_icon_label tutor_files_wrapper">

                            <div className="full-image-wrapper">
                              <img
                                onClick={() => {
                                }}
                                className="uploaded-image"
                                src={registrationDetail?.emirates_back}
                                alt="Learn and Play"
                              />
                            </div>
                            <div>
                              <label className="form-label">ID Back</label>
                              <button className="btn btn-primary" onClick={() => {
                                onFilerViewerDialogOpen(registrationDetail?.emirates_back);
                              }}>View File</button>
                            </div>

                          </div>


                        </div>
                      </div>

                      <div className="row row-wrap">
                        {registrationDetail?.immigrant_front && <div className="col-md-6 ">
                          <div className="tutor_info_icon_label tutor_files_wrapper">

                            <div className="full-image-wrapper">
                              <img
                                onClick={() => {
                                  // onFilerViewerDialogOpen(tutorDetails.id_proof_front);
                                }}
                                className="uploaded-image"
                                src={registrationDetail?.immigrant_front}
                                alt="Learn and Play"
                              />
                            </div>
                            <div>
                              <label className="form-label">Passport Front</label>
                              <button className="btn btn-primary" onClick={() => {
                                onFilerViewerDialogOpen(registrationDetail?.immigrant_front);
                              }}>View File</button>
                            </div>

                          </div>


                        </div>}

                        {registrationDetail?.immigrant_back && <div className="col-md-6 ">
                          <div className="tutor_info_icon_label tutor_files_wrapper">

                            <div className="full-image-wrapper">
                              <img
                                onClick={() => {
                                }}
                                className="uploaded-image"
                                src={registrationDetail?.immigrant_back}
                                alt="Learn and Play"
                              />
                            </div>
                            <div>
                              <label className="form-label">Passport Back</label>
                              <button className="btn btn-primary" onClick={() => {
                                onFilerViewerDialogOpen(registrationDetail?.immigrant_back);
                              }}>View File</button>
                            </div>


                          </div>

                        </div>}
                      </div>

                      {!isSchoolUniversityReg && <div className="row row-wrap">
                        <div className="col-md-6 ">
                          <div className="tutor_info_icon_label tutor_files_wrapper">

                            <div className="full-image-wrapper">
                              <img

                                className="uploaded-image"
                                src={registrationDetail?.profile_image}
                                alt="Learn and Play"
                              />
                            </div>

                            <div>
                              <label className="form-label">Profile</label>
                              <button className="btn btn-primary" onClick={() => {
                                onFilerViewerDialogOpen(registrationDetail?.profile_image);
                              }}>View File</button>
                            </div>

                          </div>


                        </div>

                        {GetSessionStorageData(STORAGE_KEYS.ROLE) != NUMBER_CONSTANTS.FIVE && (
                          <div className="col-md-6 ">
                            <div className="tutor_info_icon_label tutor_files_wrapper">
                              <div className="full-image-wrapper">
                                <img
                                  onClick={() => {
                                  }}
                                  className="drive-img"
                                  src={driveImg}
                                  alt="Learn and Play"
                                />
                              </div>
                              <div>
                                <label className="form-label">Curriculum vitae</label>
                                <button className="btn btn-primary" onClick={() => {
                                  if (GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FOUR) {
                                    window.open(registrationDetail?.tutor_cv, '_blank');
                                  }
                                  //  else if (GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FIVE) {
                                  //   window.open(registrationDetail?.camp_broucher[0], '_blank');
                                  // } 
                                  else {
                                    window.open(registrationDetail?.trainer_cv, '_blank');
                                  }
                                }}>View File</button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>}

                      {!isSchoolUniversityReg && <div className="row mt-3">
                        <div className="col-md-12">
                          <label className="form-label">Certificates</label>
                          <div className="certificates-wrapper">

                            {registrationDetail?.certificates?.map((file: any) => {
                              return file?.split('.')[file?.split('.').length - 1] === "pdf" ?
                                <div className="drive-image-wrapper">
                                  <img className="drive-img" src={driveImg} onClick={() => {
                                    window.open(file, '_blank')
                                  }} />
                                </div>

                                :
                                <div className="full-image-wrapper">
                                  <img className="uploaded-image" src={file} onClick={() => {
                                    onFilerViewerDialogOpen(file);
                                  }} />
                                </div>

                            }
                            )}
                          </div>

                        </div>
                      </div>}

                      {!isSchoolUniversityReg && <div className="row mt-3">
                        {registrationDetail?.trade_license && <div className="col-md-12">
                          <label className="form-label">Trade Licence</label>
                          <div className="certificates-wrapper">                            
                          {registrationDetail?.trade_license?.split('.')[registrationDetail?.trade_license?.split('.').length - 1] === "pdf" ?
                                <div className="drive-image-wrapper">
                                  <img className="drive-img" src={driveImg} onClick={() => {
                                    window.open(registrationDetail?.trade_license, '_blank');
                                  }} />
                                </div>

                                :
                                <div className="full-image-wrapper">
                                  <img className="uploaded-image" src={registrationDetail?.trade_license} onClick={() => {
                                    onFilerViewerDialogOpen(registrationDetail?.trade_license);
                                  }} />
                                </div>}

                            {/* }
                            )} */}
                          </div>

                        </div>}
                      </div>}
                    </div>


                    {!isSchoolUniversityReg && <div className="mt-4">
                      <h4>Banking Information</h4>
                      <div className="row row-wrap">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="form-items">
                            <label className="form-label">{t("Bank name")}</label>
                            <Field
                              name={BANKING_INFORMATION.BANK_NAME}
                              className="email-input"
                              placeholder={t("Bank name")}
                              value={registrationDetail[BANKING_INFORMATION.BANK_NAME]}
                            />
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="form-items">
                            <label className="form-label">{t("Bank branch name")}</label>
                            <Field
                              name={BANKING_INFORMATION.BANK_BRANCH_NAME}
                              className="email-input"
                              placeholder={t("Bank branch name")}
                              value={registrationDetail[BANKING_INFORMATION.BANK_BRANCH_NAME]}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-wrap">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="form-items">
                            <label className="form-label">{t("Account holder name")}</label>
                            <Field
                              name={BANKING_INFORMATION.ACCOUNT_HOLDER_NAME}
                              className="email-input"
                              placeholder={t("Account holder name")}
                              value={registrationDetail[BANKING_INFORMATION.ACCOUNT_HOLDER_NAME]}
                            />
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="form-items">
                            <label className="form-label">{t("Account Number")}</label>
                            <Field
                              name={BANKING_INFORMATION.ACCOUNT_NUMBER}
                              className="email-input"
                              placeholder={t("Account Number")}
                              value={registrationDetail[BANKING_INFORMATION.ACCOUNT_NUMBER]}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-wrap">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label className="form-label">{t("SWIFT Code")}</label>
                          <Field
                            name={BANKING_INFORMATION.SWIFT_CODE}
                            className="email-input"
                            placeholder={t("SWIFT Code")}
                            value={registrationDetail[BANKING_INFORMATION.SWIFT_CODE]}
                          />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label className="form-label">{t("IBAN Number")}</label>
                          <Field
                            name={BANKING_INFORMATION.IBAN}
                            className="email-input"
                            placeholder={t("IBAN Number")}
                            value={registrationDetail[BANKING_INFORMATION.IBAN]}
                          />
                        </div>
                      </div>
                    </div>}



                  </div>



                );
              }}
            </Formik>
          </div>

          <div className="bi-buttons-wrap">
            <button
              className="btn btn-back"
              onClick={() => onNavigate(userType === ADMIN_ROLES.SCHOOL || userType === ADMIN_ROLES.UNIVERSITY ? NUMBER_CONSTANTS.THREE : NUMBER_CONSTANTS.FIVE)}
            >
              Back
            </button>
            <button
              className="btn btn-next"
              type="submit"
              onClick={() => {
                onRegisterSP()
              }}
            >
              Submit
            </button>
          </div>
        </Card>

      </div>
    </div>
  )
}

export default Verify;